import React from "react";
import GroupRoutePremiumPage from "../components/GroupRoutePremiumPage";
import { groupRouteConfigs } from "../data/groupRouteConfigs";
import { generatedGroupRouteConfigs } from "../data/generatedCityRouteConfigs";

const GroupRoutePage = ({ routeKey, variant = "minibus" }) => {
  const routeEntry = groupRouteConfigs[routeKey] || generatedGroupRouteConfigs[routeKey];

  if (!routeEntry) return null;

  return (
    <GroupRoutePremiumPage
      variant={variant}
      route={routeEntry.route}
      configs={routeEntry.configs}
    />
  );
};

export default GroupRoutePage;
